class ClientAuthorizationsController {
  constructor() {
    this.name = 'clientAuthorizations';
    this.breadcrumbsItems = [{
        label: 'Authorizations',
        isCurrent: true,
    }];

    this.userAuthorizations = {
      tableHead: {
        row: [{
          fieldContent: 'Name',  
        }, {
          fieldContent: 'Global View Employee ID',
        }, {
          fieldContent: 'Paygroup Access',
        }, {
          fieldContent: 'Access Type',
        }],
      },
      tableBody: [{
        row: [{
          fieldContent: 'Carl Garza',  
        }, {
          fieldContent: '79033',
        }, {
          fieldContent: 'All paygroups',
        }, {
          fieldContent: 'Read & Write',
        }],
      }, {
        row: [{
          fieldContent: 'Katherine Nguyen',  
        }, {
          fieldContent: '5009',
        }, {
          fieldContent: 'Executives, Regular Employees',
        }, {
          fieldContent: 'Read',
        }],
      }, {
        row: [{
          fieldContent: 'Ophelia Evans',  
        }, {
          fieldContent: '6288',
        }, {
          fieldContent: 'Consultants, Regular Employees',
        }, {
          fieldContent: 'Read',
        }],
      }, {
        row: [{
          fieldContent: 'Sean Lawrence',  
        }, {
          fieldContent: '92408',
        }, {
          fieldContent: 'Regular Employees',
        }, {
          fieldContent: 'Write',
        }],
      }, {
        row: [{
          fieldContent: 'Teresa Nichols',  
        }, {
          fieldContent: '26105',
        }, {
          fieldContent: 'Executives, Consultants, Regular Employees',
        }, {
          fieldContent: 'Read & Write',
        }],
      }, {
        row: [{
          fieldContent: 'Fannie Schmidt',  
        }, {
          fieldContent: '79033',
        }, {
          fieldContent: 'Regular Employees',
        }, {
          fieldContent: 'Write',
        }],
      }, {
        row: [{
          fieldContent: 'Alejandro Benson',  
        }, {
          fieldContent: '57569',
        }, {
          fieldContent: 'All paygroups',
        }, {
          fieldContent: 'Write',
        }],
      },]
    };    

    this.countriesMultiple = {
      maxItems: 10,
      valueField: 'code',
      labelField: 'name',
      searchField: ['code', 'name'],
      options: [{
        name: "United States", code: "US"
      },{
        name: "United Kingdom", code: "UK"
      }, {
        name: "Japan", code: "JP"
      }]
    };
    
    this.companiesMultiple = {
      maxItems: 10,
      valueField: 'code',
      labelField: 'name',
      searchField: ['code', 'name'],
      options: [{
        name: "All companies", code: "AC"
      },{
        name: "Athlon", code: "ATH"
      }, {
        name: "Tremendous Technologies", code: "TT"
      }]
    };
    
    this.paygroupsMultiple = {
      maxItems: 10,
      valueField: 'code',
      labelField: 'name',
      searchField: ['code', 'name'],
      options: [{
        name: "All paygroups", code: "AP"
      },{
        name: "Paygroup 1", code: "P1"
      }, {
        name: "Paygroup 2", code: "P2"
      }]
    };
    this.test = "test works here"
  }
  
  toggleSideModal() {
    this.sideModalOpen = !this.sideModalOpen
  }
}

export default ClientAuthorizationsController;



// WEBPACK FOOTER //
// ./src/app/pages/clientAuthorizations/clientAuthorizations.controller.js